export enum SupportingDocumentation {
  mostRecentTaxReturn = 0,
  w2Form = 1,
  other = -1
}
